import uuid4 from "uuid4";
import { useState } from "react";
import "./commentFormStyle.css";

function CommentForm({ addComment, light }) {
  let [author, setAuthor] = useState("");
  let [comment, setComment] = useState("");
  function updateAuthor(e) {
    setAuthor(e.target.value);
  }
  function updateComment(e) {
    setComment(e.target.value);
  }

  function submitForm(e) {
    e.preventDefault();
    addComment({
      id: uuid4,
      author: author === "" ? "Anon Author" : author,
      content: comment,
    });
    setComment("");
  }
  return (
    <div className={light ? "lightForm" : "darkForm"}>
      <form onSubmit={submitForm}>
        <div className="inputFields">
          <label htmlFor="AuthorInput" className="authorInput">
            Author:
          </label>
          <input
            type="text"
            id="AuthorInput"
            value={author}
            onChange={updateAuthor}
            className={light ? "lightInput" : "darkInput"}
          ></input>
        </div>
        <div className="inputFields">
          <label htmlFor="CommentInput">Comment:</label>
          <textarea
            id="CommentInput"
            required
            value={comment}
            onChange={updateComment}
            className={light ? "lightInput textArea" : "darkInput textArea"}
          ></textarea>
        </div>
        <button type="submit" className={light ? "lightButton" : "darkButton"}>
          Submit
        </button>
      </form>
    </div>
  );
}

export default CommentForm;
